export default async function useGetShopwarePageById(ids: any) {
    const config = useRuntimeConfig();

    let idArray = [];

    if (Array.isArray(ids.value)) {
        idArray = ids.value;
    } else if (ids.value) {
        idArray = [ids.value];
    }

    if (idArray.length === 0) {
        return {};
    }

    let data;
    try {
        const result = await $fetch(config.public.shopwareEndpoint + 'category', {
            method: 'POST',
            body: {
                ids: idArray,
                includes: {
                    category: ['id', 'seoUrls'],
                    seo_url: ['seoPathInfo', 'routeName'],
                },
                associations: {
                    seoUrls: {},
                },
            },
            headers: {
                'Content-Type': 'application/json',
                'sw-access-key': config.public.shopwareToken,
            },
        });
        data = result.elements;
    } catch (error) {
        console.error('Error fetching Shopware page:', error);
        return 'error';
    }

    if (!data) {
        return 'error';
    }

    const shopwareSlugs = data.reduce((acc, category) => {
        acc[category.id] = category.seoUrls[0].seoPathInfo;
        return acc;
    }, {});

    return shopwareSlugs;
}
